<template>
   <span>{{now}} [{{islamicDate}}]</span> 
</template>
<script>
module.exports = {
    data(){
        return {
            'now': '',
            'islamicDate': ''
        }
    },
    created(){
        const self = this
        setInterval(()=>{
            self.now = new Date().toLocaleString({'locales':'ar-SA'})
        },1000)
        this.islamicDate = new Intl.DateTimeFormat('ar-SA', {day: 'numeric', month: 'numeric',year : 'numeric'}).format(Date.now());
    }
}
</script>